<template>
  <div id="app">
    <home/>
  </div>
</template>

<script>
import Home from "@/h5/Home";
import "@/css/style.css";
import "@/css/home.css";

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style>
#app {
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

}
#app:after{
  content: '';
  width: 100%;
  height: 40%;
  position: absolute;
  top: 0;
  left: 0;
  background-image: -moz-linear-gradient( 0deg, rgba(70,10,136,0.05) 0%, rgba(144,16,221,1) 100%);
  background-image: -webkit-linear-gradient( 0deg, rgba(70,10,136,0.05) 0%, rgba(144,16,221,1) 100%);
  background-image: -ms-linear-gradient( 0deg, rgba(70,10,136,0.05) 0%, rgba(144,16,221,1) 100%);
  background-image: linear-gradient( 0deg, rgba(70,10,136,0.05) 0%, rgba(144,16,221,1) 100%);
}


</style>
